import React, { useEffect, useState } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const withRedirectIfAlreadyLoggedIn = <P extends object>(Component: React.ComponentType<P>) => {
    const AuthenticatedComponent: React.FC<P> = (props) => {
        const { user, checkUser } = useAuth();

        useEffect(() => {
            const verifyUser = async () => {
                console.log("useffetct withRedirectIfAlreadyLoggedIn", );
                await checkUser();
            }
            verifyUser();
        }, []);

        console.log("user", user);

        if (user && user !== null) {
            return <Navigate to="/calc" replace />;
        }

        return <Component {...props} />;
    };

    return AuthenticatedComponent;
};

export default withRedirectIfAlreadyLoggedIn;
